import {createContext} from "react";
import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {ClientEntityContextValue} from "../context";

export const ClientEntityContext = createContext<ClientEntityContextValue>({
  entity: {} as ClientEntity,
  setEntity: entity => {}
});
